// This file contains all the API routes used in the application.
export const IS_DEVELOPMENT_MODE = true;
export const BASE_URL = "http://localhost:4000/api";
// export const BASE_URL = 'https://f-o-r-automatisation-backend-t545.onrender.com/api';
export const LOGIN_URL = `${BASE_URL}/login`;
export const USERS_URL = `${BASE_URL}/users`;
export const ROLES_URL = `${BASE_URL}/roles`;
export const CUSTOMERS_URL = `${BASE_URL}/customers`;
export const DRIVER_URL = `${BASE_URL}/drivers`;
export const STORE_URL = `${BASE_URL}/stores`;
export const SUPPLIERS_URL = `${BASE_URL}/suppliers`;
export const DECLARATIONS_URL = `${BASE_URL}/declarations`;
export const PRODUCTS_URL = `${BASE_URL}/products`;
export const PURCHASES_URL = `${BASE_URL}/purchases`;
export const SALES_URL = `${BASE_URL}/sales`;
export const INVENTORY_URL = `${BASE_URL}/inventory`;
export const ACCOUNT_TYPES_URL = `${BASE_URL}/account-types`;
export const ACCOUNT_SUB_TYPES_URL = `${BASE_URL}/account-sub-types`;
export const CA_URL = `${BASE_URL}/cash-of-accounts`;
export const REFRESH_URL = `${BASE_URL}/refresh`;
export const CATRANSACTIONS_URL = `${BASE_URL}/ca-transactions`;
export const DASHBOARD_URL = `${BASE_URL}/dashboard`;
export const EXPENSES_URL = `${BASE_URL}/dashboard/expenses`;
export const BANK_POSITIONS_URL = `${BASE_URL}/dashboard/bank-positions`;
export const CHANGE_PASSWORD_URL = `${BASE_URL}/change-password`;
export const PERMISSIONS_URL = `${BASE_URL}/permissions`;
export const PRODUCT_CATEGORIES_URL = `${BASE_URL}/product-categories`;
export const BANK_URL = `${BASE_URL}/banks`;
export const BANK_TRANSACTIONS_URL = `${BASE_URL}/bank-transactions`;
export const TRANSPORT_URL = `${BASE_URL}/transports`;
export const ESL_URL = `${BASE_URL}/esl`;
export const TRANSIT_FEES_URL = `${BASE_URL}/transit-fees`;
export const DECLARATION_DETAIL_URL = `${BASE_URL}/declaration-detail`;
export const SALE_DETAIL_URL = `${BASE_URL}/sale-detail`;
export const PROVISIONS_URL = `${BASE_URL}/provisions`;
export const UNIT_OF_MEASUREMENT_URL = `${BASE_URL}/unit-of-measurements`;
export const JOURNAL_ENTRY_URL = `${CATRANSACTIONS_URL}/journal-entry`;
